import ReCAPTCHA, { ReCAPTCHAProps } from "react-google-recaptcha";

interface GoogleReCAPTCHAProps extends ReCAPTCHAProps {
  handleChangeReCAPTCHA: (token: string | null) => void;
  handleErroredReCAPTCHA?: () => void;
  handleExpiredReCaptcha?: () => void;
  captchaRef: any;
  isInvisible?: boolean;
}

export const GoogleReCAPTCHA = ({
  handleChangeReCAPTCHA,
  handleErroredReCAPTCHA,
  handleExpiredReCaptcha,
  captchaRef,
  isInvisible = false,
}: GoogleReCAPTCHAProps) => {
  const siteKey = isInvisible
    ? "6LdTTeorAAAAAAOlw7W4v1f2TfeIZomfOdM0NRKJ"
    : "6LdTTeorAAAAANhse3xd-aPGQ1tXVw7FrMufzjLi";
  return (
    <ReCAPTCHA
      ref={captchaRef}
      sitekey={siteKey ?? ""}
      onChange={handleChangeReCAPTCHA}
      onErrored={handleErroredReCAPTCHA}
      onExpired={handleExpiredReCaptcha}
      size={isInvisible ? "invisible" : "normal"}
    />
  );
};
